import axios from 'axios';
import { functionExist } from 'cgil-html-utils';
import { DEFAULT_BASE_SERVER_URL, getLog } from '../config';
import { getLocalJwtTokenAuth } from './Login';

const log = getLog('Degradation', 4, 1);

let instance = null;


/*  Singleton to retrieve objet
 */
class Degradation {
  constructor() {
    if (!instance) {
      instance = this;
    }
    // to test whether we have singleton or not and store how old is data
    this.time = new Date();
    this.data = [];
    this.isReady = false;
    return instance;
  }

  getErrorMessage(method, msg, err) {
    let errMessage = msg;
    log.e(errMessage);
    if (err.response) {
      const errResponse = err.response;
      log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
      this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
      errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.message}`;
      this.lastError = err.response;
    } else if (err.request) {
      log.e(' -- The request was made, but no response was received from the server', err.request);
      this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
      errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
      this.lastError = err.request;
    } else {
      log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
      this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
      errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
      this.lastError = err.message;
    }
    return errMessage;
  }

  getList(idSector, callbackLoaded) {
    const method = 'getList';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.get(`${DEFAULT_BASE_SERVER_URL}/api/degradations?idSector=${idSector}`)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios get success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.get`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  getListFiltered(idCategorie, idSector, callbackLoaded) {
    const method = 'getListFiltered';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.get(`${DEFAULT_BASE_SERVER_URL}/api/degradations_filtered/${idCategorie}?idSector=${idSector}`)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios get success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.get`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  getListPictures(idDegradation, callbackLoaded) {
    const method = 'getList';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.get(`${DEFAULT_BASE_SERVER_URL}/api/degradations/pictures/${idDegradation}`)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios get success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.get`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  get(idDegradation, callbackLoaded) {
    const method = 'getDegradation';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.get(`${DEFAULT_BASE_SERVER_URL}/api/degradations/${idDegradation}`)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios get success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.get`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  new(data, callbackLoaded) {
    const method = 'newDegradation';
    log.t(`## IN ${method}, data:`, data);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.post(`${DEFAULT_BASE_SERVER_URL}/api/degradations`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios get success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.post`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  modify(data, callbackLoaded) {
    const method = 'modifyDegradation';
    log.t(`## IN ${method} data :`, data);
    const { id } = data;
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.put(`${DEFAULT_BASE_SERVER_URL}/api/degradations/${id}`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios put success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.put`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  delete(idDegradationToDelete, callbackLoaded) {
    const method = 'deleteDegradation';
    log.t(`## IN ${method} id:${idDegradationToDelete}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.delete(`${DEFAULT_BASE_SERVER_URL}/api/degradations/${idDegradationToDelete}`)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios delete success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.delete`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  validate(id, callbackLoaded) {
    const method = 'validateDegradation';
    const data = { id };
    const idDegradation = data.id;
    log.t(`## IN ${method} id:${idDegradation}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.put(`${DEFAULT_BASE_SERVER_URL}/api/degradations/validate/${idDegradation}`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios delete success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.put`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  unvalidate(id, callbackLoaded) {
    const method = 'unvalidateDegradation';
    const data = { id };
    const idDegradation = data.id;
    log.t(`## IN ${method} id:${idDegradation}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.put(`${DEFAULT_BASE_SERVER_URL}/api/degradations/unvalidate/${idDegradation}`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios delete success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.put`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }

  terminate(id, callbackLoaded) {
    const method = 'terminateDegradation';
    const data = { id };
    const idDegradation = data.id;
    log.t(`## IN ${method} id:${idDegradation}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.put(`${DEFAULT_BASE_SERVER_URL}/api/degradations/terminate/${idDegradation}`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios delete success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.put`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }
}
const degradation = new Degradation();
export default degradation;
